import Bugsnag from '@bugsnag/js';
import { BRANCH_KEY, HUB_KEY, BRANCH_ADDRESS_KEY } from '@/helpers/consts';
function notifyError(e, metadata) {
    if (Bugsnag.isStarted()) {
        Bugsnag.notify(e, event => {
            event.addMetadata('storage', metadata);
        });
    }
    else {
        console.warn('[storage]', e, metadata);
    }
}
const APPOINTMENT_STORAGE_KEYS = [BRANCH_KEY, HUB_KEY, BRANCH_ADDRESS_KEY];
function clearAppointmentStorage() {
    try {
        APPOINTMENT_STORAGE_KEYS.forEach(key => {
            window.localStorage.removeItem(key);
        });
    }
    catch (e) {
        notifyError(e, { action: 'clearAppointmentStorage', keys: APPOINTMENT_STORAGE_KEYS });
    }
}
const QUOTA_ERROR_NAMES = new Set(['QuotaExceededError', 'NS_ERROR_DOM_QUOTA_REACHED']);
function isQuotaError(e) {
    return typeof DOMException !== 'undefined' && e instanceof DOMException && QUOTA_ERROR_NAMES.has(e.name);
}
function safeSetItem(key, value) {
    try {
        window.localStorage.setItem(key, value);
    }
    catch (e) {
        if (isQuotaError(e)) {
            clearAppointmentStorage();
            try {
                window.localStorage.setItem(key, value);
            }
            catch (retryError) {
                notifyError(retryError, { key, valueLength: value.length });
            }
        }
        else {
            notifyError(e, { key, errorName: e.name });
        }
    }
}
export { safeSetItem, clearAppointmentStorage, };
